{
  "filter": "Filter",
  "filters": "Filter",
  "ok": "OK",
  "cancel": "Abbrechen",
  "close": "Schließen",
  "delete": "Löschen",
  "update": "Aktualisieren",
  "remove": {
    "user": "Benutzer löschen"
  },
  "search": "Suchen",
  "back": "Zurück",
  "validate": "Bestätigen",
  "save": "Speichern",
  "archive": "Archivieren",
  "send": "Senden",
  "disable": "Deaktivieren",
  "enable": "Aktivieren",
  "create": {
    "_": "Erstellen",
    "rootCa": "Root-CA laden"
  },
  "next": "Weiter",
  "previous": "Zurück",
  "test": {
    "pki": "Verbindung testen"
  },
  "slider": {
    "enable": "Auswahl aktivieren",
    "disable": "Auswahl deaktivieren"
  },
  "download": "Herunterladen",
  "add": "Hinzufügen",
  "import": "Importieren",
  "retryLogin": "Versuchen Sie erneut, sich anzumelden.",
  "retryLogout": "Versuchen Sie erneut, sich abzumelden.",
  "confirm": "Bestätigen",
  "deactivate": "Deaktivieren",
  "activate": "Aktivieren",
  "upload": "Hochladen",
  "copied": "Kopiert",
  "copiedTitle": "In die Zwischenablage kopieren",
  "edit": "Bearbeiten"
}
